'use strict';

var debug;
var assert;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:thirdApps:installed');
    assert = require('assert');
}

var _invoke = require('../invoke');

/**
 * 检查第三方软件安装情况
 *
 * 目前支持支付宝（`alipay`）
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof thirdApps
 * @static
 * @name installed
 * @param {String} appName 软件名
 * @return {Promise<status>}
 * @example
 *  var hbnb = request('@hfe/hbnb');
 *  hbnb.thirdApps.installed('alipay')
 *      .then(function(status) {
 *          status = true || false
 *      });
 */
module.exports = function(appName) {
    if (process.env.NODE_ENV !== 'production') {
        debug('app is %s', appName);
        assert(['alipay'].indexOf(appName) >= 0);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('third_apps', 'installed', {
            appName: appName,
            callback: function(status) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('status is %j', status);
                }

                if (status && status.installed) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/thirdApps/installed.js
// module id = 259
// module chunks = 4